import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import products from "../services/products";

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

const categories = [
  { name: "Հեռախոսներ", icon: "📱" },
  { name: "Համակարգիչներ", icon: "💻" },
  { name: "Մեքենաներ", icon: "🚗" },
  { name: "Հագուստ", icon: "👕" },
  { name: "Կահույք", icon: "🛋️" },
  { name: "Էլեկտրոնիկա", icon: "🎧" },
  { name: "Անշարժ գույք", icon: "🏠" },
  { name: "Այլ", icon: "✨" },
];

  const slides = [
    {
      title: "Գտիր այն, ինչ փնտրում ես",
      text: "Հազարավոր հայտարարություններ մեկ հարթակում",
      button: "Դիտել հայտարարությունները",
      image:
        "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200",
    },
    {
      title: "Վաճառիր այն, ինչն այլևս պետք չէ",
      text: "Տեղադրիր քո հայտարարությունը մի քանի րոպեում",
      button: "Տեղադրել հայտարարություն",
      image:
        "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=1200",
    },
    {
      title: "Լավ ապրանքներ։ Լավ գներ։",
      text: "Գտիր հետաքրքիր առաջարկներ քո քաղաքում",
      button: "Սկսել գնումները",
      image:
        "https://images.unsplash.com/photo-1607082349566-187342175e2f?w=1200",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + slides.length) % slides.length
    );
  };

  const popularProducts = products.slice(0, 8);

  return (
    <>
      <Header />

      <main className="home">

        {/* =========================================
            MAIN MARKETPLACE AREA
        ========================================= */}

        <section className="marketplace-hero">
          <div className="container marketplace-layout">

            {/* SIDEBAR */}

            <aside className="category-sidebar">
              <div className="sidebar-title">
                <span>☰</span>
                <h2>Կատեգորիաներ</h2>
              </div>

              <div className="sidebar-list">
                {categories.map((category) => (
                  <Link
                    key={category.name}
                    to={`/products?category=${encodeURIComponent(
                      category.name
                    )}`}
                    className="sidebar-category"
                  >
                    <span className="sidebar-category-icon">
                      {category.icon}
                    </span>

                    <span>{category.name}</span>

                    <span className="sidebar-arrow">›</span>
                  </Link>
                ))}
              </div>

              <Link to="/products" className="all-categories">
                Բոլոր կատեգորիաները
                <span>→</span>
              </Link>
            </aside>

            {/* CAROUSEL */}

            <div className="main-carousel">

              <div
                className="carousel-track"
                style={{
                  transform: `translateX(-${currentSlide * 100}%)`,
                }}
              >
                {slides.map((slide, index) => (
                  <div className="carousel-slide" key={index}>

                    <img
                      src={slide.image}
                      alt={slide.title}
                    />

                    <div className="carousel-overlay"></div>

                    <div className="carousel-content">
                      <span className="carousel-small">
                       Առք և Վաճառք
                      </span>

                      <h1>{slide.title}</h1>

                      <p>{slide.text}</p>

                      <Link
                        to={
                          index === 1
                            ? "/create-listing"
                            : "/products"
                        }
                        className="carousel-button"
                      >
                        {slide.button}
                        <span>→</span>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* ARROWS */}

              <button
                className="carousel-arrow carousel-prev"
                onClick={prevSlide}
              >
                ‹
              </button>

              <button
                className="carousel-arrow carousel-next"
                onClick={nextSlide}
              >
                ›
              </button>

              {/* DOTS */}

              <div className="carousel-dots">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={
                      currentSlide === index
                        ? "active"
                        : ""
                    }
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>

            </div>
          </div>
        </section>


        {/* =========================================
            QUICK CATEGORIES
        ========================================= */}

        <section className="quick-categories">
          <div className="container">

            <div className="home-section-header">
              <div>
                <span>ՈՐՈՆԻՐ ԱՎԵԼԻ ՀԵՇՏ</span>
                <h2>Հանրաճանաչ կատեգորիաներ</h2>
              </div>

              <Link to="/products">
                Դիտել բոլորը →
              </Link>
            </div>

            <div className="quick-category-grid">
              {categories.slice(0, 6).map((category) => (
                <Link
                  key={category.name}
                  to={`/products?category=${encodeURIComponent(
                    category.name
                  )}`}
                  className="quick-category"
                >
                  <div className="quick-category-icon">
                    {category.icon}
                  </div>

                  <strong>{category.name}</strong>

                  <span>Դիտել →</span>
                </Link>
              ))}
            </div>

          </div>
        </section>


        {/* =========================================
            PRODUCTS
        ========================================= */}

        <section className="latest-products">
          <div className="container">

            <div className="home-section-header">
              <div>
                <span>ՆՈՐ ԱՎԵԼԱՑՎԱԾ</span>
                <h2>Վերջին հայտարարությունները</h2>
              </div>

              <Link to="/products">
                Բոլորը →
              </Link>
            </div>

            <div className="market-products-grid">
              {popularProducts.map((product) => (
                <Link
                  key={product.id}
                  to={`/products/${product.id}`}
                  className="market-product-card"
                >

                  <div className="market-product-image">

                    <img
                      src={product.image}
                      alt={product.name}
                    />

                    <button
                      className="heart-button"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      ♡
                    </button>

                    <span className="new-badge">
                      ՆՈՐ
                    </span>
                  </div>

                  <div className="market-product-info">

                    <span className="market-product-category">
                      {product.category}
                    </span>

                    <h3>{product.name}</h3>

                    <div className="product-meta">
                      <strong>{product.price}</strong>

                      <span>
                        📍 Երևան
                      </span>
                    </div>

                  </div>
                </Link>
              ))}
            </div>

          </div>
        </section>


        {/* =========================================
            FEATURE STRIP
        ========================================= */}

        <section className="features-section">
          <div className="container">

            <div className="features-grid">

              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <div>
                  <h3>Արագ և հեշտ</h3>
                  <p>
                    Գտիր կամ տեղադրիր ապրանք մի քանի րոպեում։
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <div>
                  <h3>Անվտանգ հարթակ</h3>
                  <p>
                    Հայտարարությունները ստուգվում են ադմինի կողմից։
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">💬</div>
                <div>
                  <h3>Կապ վաճառողի հետ</h3>
                  <p>
                    Կապվիր վաճառողի հետ անմիջապես։
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">🇦🇲</div>
                <div>
                  <h3>Հայաստանյան marketplace</h3>
                  <p>
                    Գտիր ապրանքներ քո քաղաքում։
                  </p>
                </div>
              </div>

            </div>

          </div>
        </section>


        {/* =========================================
            SELL CTA
        ========================================= */}

        <section className="sell-section">
          <div className="container">

            <div className="sell-banner">

              <div className="sell-content">
                <span>ՎԱՃԱՌՈՂՆԵՐԻ ՀԱՄԱՐ</span>

                <h2>
                  Ունե՞ս բան,
                  <br />
                  որը ցանկանում ես վաճառել։
                </h2>

                <p>
                  Տեղադրիր հայտարարություն և գտիր քո գնորդին։
                </p>

                <Link to="/create-listing">
                  Տեղադրել հայտարարություն
                  <span>→</span>
                </Link>
              </div>

              <div className="sell-decoration">
                <div>+</div>
                <div>+</div>
                <div>+</div>
              </div>

            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}

export default Home;